<template>
  <v-flex>
    <div v-if="getCost() != null" mt-1 class="cost-box" v-bind:style="styleForBox">
      <div v-if="fixedCost() != null">
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-icon color="primary" dark v-on="on">info</v-icon>
          </template>
          <p style="font-size: 12px;">{{ fixedCost() }}</p>
        </v-tooltip>
      </div>
      <div>
        <p v-if="getCost() != null" class="cost-amount">£{{(getCost()/100).toFixed(2)}}</p>
        <p
          v-if="getCostPromotion() != null"
          class="cost-amount"
        >&nbsp;→&nbsp;£{{(getCostPromotion()/100).toFixed(2)}}</p>
      </div>
    </div>
  </v-flex>
</template>

<script>
export default {
  name: "EstimatedCost",
  model: {
    prop: "content",
    event: "input"
  },
  components: {},
  props: {
    bookingForm: Object
  },
  data() {
    return {};
  },
  computed: {
    styleForBox: function() {
      return {
        "background-color":
          this.getCostPromotion() != null ? "#8ff7b4" : "#e3f2fd"
      };
    }
  },
  methods: {
    getCost: function() {
      if (this.bookingForm.costs != null) {
        var bookingForm = this.bookingForm;

        var costForRideType = bookingForm.costs.find(function(cost) {
          return cost.id == bookingForm.booking.ride_type;
        });
        if (costForRideType != null) {
          return costForRideType.estimate;
        } else {
          return null;
        }
      }
    },
    getCostPromotion: function() {
      if (this.bookingForm.costs != null) {
        var bookingForm = this.bookingForm;

        var costForRideType = bookingForm.costs.find(function(cost) {
          return cost.id == bookingForm.booking.ride_type;
        });

        if (costForRideType != null) {
          return costForRideType.estimate_promotion;
        } else {
          return null;
        }
      }
    },
    fixedCost: function() {
      if (this.bookingForm.costs != null) {
        var bookingForm = this.bookingForm;

        var costForRideType = bookingForm.costs.find(function(cost) {
          return cost.id == bookingForm.booking.ride_type;
        });

        if (costForRideType != null) {
          return costForRideType.fixed_cost;
        } else {
          return null;
        }
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.cost-box {
  border-radius: 6px;
  padding: 6px;
}

.cost-amount {
  font-size: 16px;
  font-weight: 500;
}

.est-text {
  font-size: 16px;
  font-weight: 700;
}
</style>
